<template>
  <div>
    <div class="card p-2 mb-2 bg-gray text-white text-uppercase">
      <div class="row heading-small">
        <div class="col-md-1 font-heading">Eye</div>
        <div class="col-md-1 px-1 font-heading">Visus Awal</div>
        <div class="col-md-1 px-1 font-heading">PH</div>
        <div class="col-md-1 px-1 font-heading">TIO</div>
        <div class="col-md-2 px-1 font-heading">KM Lama</div>
        <div class="col-md-2 px-1 font-heading">Koreksi</div>
        <div class="col-md-1 px-1 font-heading">Visus Akhir</div>
        <div class="col-md-3 font-heading">Catatan</div>
      </div>
    </div>
    <div class="card p-2 mb-1">
      <div class="row">
        <div class="col-md-1">
          <h5 class="pt-2 mb-0">O.D.</h5>
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="od_visus_l"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="od_ph"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="od_tio"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-2 px-1">
          <div class="input-group">
            <input
              type="text"
              placeholder="S"
              required="required"
              class="form-control"
              name="od_s_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="C"
              required="required"
              class="form-control"
              name="od_c_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="X"
              required="required"
              class="form-control"
              name="od_x_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="A"
              required="required"
              class="form-control"
              name="od_add_lama"
              @input="(e) => handleChange(e)"
            />
          </div>
        </div>
        <div class="col-md-2 px-1">
          <div class="input-group">
            <input
              type="text"
              placeholder="S"
              required="required"
              class="form-control"
              name="od_s_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="C"
              required="required"
              class="form-control"
              name="od_c_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="X"
              required="required"
              class="form-control"
              name="od_x_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="A"
              required="required"
              class="form-control"
              name="od_add_kor"
              @input="(e) => handleChange(e)"
            />
          </div>
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="od_visus_r"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-3">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="od_catatan"
            @input="(e) => handleChange(e)"
          />
        </div>
      </div>
    </div>
    <div class="card p-2 mb-1">
      <div class="row">
        <div class="col-md-1">
          <h5 class="pt-2 mb-0">O.S.</h5>
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="os_visus_l"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="os_ph"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="os_tio"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-2 px-1">
          <div class="input-group">
            <input
              type="text"
              placeholder="S"
              required="required"
              class="form-control"
              name="os_s_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="C"
              required="required"
              class="form-control"
              name="os_c_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="X"
              required="required"
              class="form-control"
              name="os_x_lama"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="A"
              required="required"
              class="form-control"
              name="os_add_lama"
              @input="(e) => handleChange(e)"
            />
          </div>
        </div>
        <div class="col-md-2 px-1">
          <div class="input-group">
            <input
              type="text"
              placeholder="S"
              required="required"
              class="form-control"
              name="os_s_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="C"
              required="required"
              class="form-control"
              name="os_c_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="X"
              required="required"
              class="form-control"
              name="os_x_kor"
              @input="(e) => handleChange(e)"
            />
            <input
              type="text"
              placeholder="A"
              required="required"
              class="form-control"
              name="os_add_kor"
              @input="(e) => handleChange(e)"
            />
          </div>
        </div>
        <div class="col-md-1 px-1">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="os_visus_r"
            @input="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-3">
          <input
            type="text"
            placeholder=""
            required="required"
            class="form-control"
            name="os_catatan"
            @input="(e) => handleChange(e)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabelOphthalmic",
  components: {},
  props: {},
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
